import { ProductLabelText } from '@/components/ProductPrice/ProductPrice.styled'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { SxProps } from '@mui/material'

interface ProductLabelsProps {
  className?: string
  colorClassName?: string | null
  labelText: string | null
  sx?: SxProps
}

export const ProductLabels: React.FC<ProductLabelsProps> = ({ className = '', colorClassName = '', labelText, sx }) => {
  const { translate } = useTranslations()
  const classNameString = `${className} ${colorClassName}`

  return labelText ? (
    <ProductLabelText title={translate(labelText)?.toString()} sx={{ ...sx }} className={classNameString}>
      {translate(labelText)}
    </ProductLabelText>
  ) : null
}
